export class HttpVaultRequestRepository {
    constructor(http, logger) {
        this.http = http;
        this.logger = logger;
        this.lastResult = null;
        this.lastPendingVaultRequests = null;
    }
    async getVaultRequests() {
        try {
            this.logger.logInformation('HTTP Vault Request Repository: Getting vault requests...');
            const result = await this.http.get('vault-requests');
            // save in case of a future api call error
            this.lastResult = result;
            this.logger.logInformation('HTTP Vault Request Repository: Vault requests successfully loaded.');
            return result;
        }
        catch (ex) {
            this.logger.logWarning(ex);
            // return last known result
            if (this.lastResult !== null) {
                this.logger.logInformation('HTTP Vault Request Repository: Returning last known result.');
                return this.lastResult;
            }
            throw ex;
        }
    }
    async getPendingVaultRequests() {
        try {
            this.logger.logInformation('HTTP Vault Request Repository: Getting pending vault requests...');
            const result = await this.http.get('vault-requests/pending');
            // save in case of a future api call error
            this.lastPendingVaultRequests = result;
            this.logger.logInformation('HTTP Vault Request Repository: Vault requests successfully loaded.');
            return result;
        }
        catch (ex) {
            this.logger.logWarning(ex);
            // return last known result
            if (this.lastPendingVaultRequests !== null) {
                this.logger.logInformation('HTTP Vault Request Repository: Returning last known result.');
                return this.lastPendingVaultRequests;
            }
            throw ex;
        }
    }
    addVaultRequest(data) {
        return this.http.post('vault-requests', data);
    }
    approveRequest(id) {
        return this.http.post(`vault-requests/${id}/approve`, null);
    }
    rejectRequest(id) {
        return this.http.post(`vault-requests/${id}/reject`, null);
    }
}
